var exports = {
  "V0": "miniHeaderInner__PNUGO_",
  "DD": "title__rbH5Fa",
  "ai": "number__psmPBx",
  "UH": "stateLabel__9bt2H7",
  "sb": "navigationDivider__r4fnNP",
  "yu": "metadata__jEOHXh",
  "o1": "actions__tWsgi0",
};

module.exports = exports;
